module.exports = __webpack_public_path__ + "img/117.857bc68e.jpg";